"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLatestUsed = exports.contractNumbersCancel = exports.getContractNumbersFiles = exports.getContractNumbersForSelect = exports.updateContractNumber = exports.createContractNumber = exports.getContractNumber = exports.deleteItem = exports.getContractNumbers = void 0;
const tslib_1 = require("tslib");
const Api = tslib_1.__importStar(require("api/privateRequest"));
const parsers_1 = require("api/references/contractNumber/parsers");
const getContractNumbers = async (params) => {
    const response = await Api.get('references/procurement-numbers', params);
    return (0, parsers_1.parseContractNumbers)(response);
};
exports.getContractNumbers = getContractNumbers;
const deleteItem = async (id) => {
    return await Api.deleteItem(`references/procurement-numbers/${id}`);
};
exports.deleteItem = deleteItem;
const getContractNumber = async (id) => {
    const response = await Api.get('references/procurement-numbers/' + id);
    return (0, parsers_1.parseContractNumber)(response);
};
exports.getContractNumber = getContractNumber;
const createContractNumber = async (params) => {
    const response = await Api.post('references/procurement-numbers', params);
    return (0, parsers_1.parseContractNumber)(response);
};
exports.createContractNumber = createContractNumber;
const updateContractNumber = async (id, params) => {
    const response = await Api.patch('references/procurement-numbers/' + id, params);
    return (0, parsers_1.parseContractNumber)(response);
};
exports.updateContractNumber = updateContractNumber;
const getContractNumbersForSelect = async (params) => {
    const response = await Api.get('references/procurement-numbers', params);
    return (0, parsers_1.parseContractNumbersForSelect)(response);
};
exports.getContractNumbersForSelect = getContractNumbersForSelect;
const getContractNumbersFiles = async (params) => {
    const response = await Api.get('references/procurement-numbers/export', params);
    return (0, parsers_1.parseContractNumberFiles)(response);
};
exports.getContractNumbersFiles = getContractNumbersFiles;
const contractNumbersCancel = async (id) => {
    const response = await Api.patch(`references/procurement-numbers/${id}/cancel`, {});
    return (0, parsers_1.parseContractNumber)(response);
};
exports.contractNumbersCancel = contractNumbersCancel;
const getLatestUsed = async () => {
    const response = await Api.get('references/procurement-numbers/latest-used');
    return (0, parsers_1.parseContractNumber)(response);
};
exports.getLatestUsed = getLatestUsed;
